<template>
    <div>
        <div class="min_1200 header_t">
            <div class="w_1200 header_t_w">
                <h1 class="fl logo">
                    <router-link tag="a" to="/">
                        <img src="../assets/images/icon/logo.png" alt="韶关市国土资源交易系统">
                    </router-link>
                </h1>
                <div class="fr header_t_r hover_arrow">
                    <a :href="$URL.JYXT" class="login_btn_a box_sizing transition_a box">
                        <span class="login_icon box_mr8 icon_public"></span>
                        <span class="text_m">登录系统</span>
                    </a>
                </div>
                <!--end头文件右-->
            </div>
        </div>
        <!--end头文件-->

        <div class="min_1200 nav blue_bj tofixed" id="header">
            <!--<ul class="w_1200 nav_ul" @click="clickNav">-->
            <!--<li class="item_li"><a href="/"" class="item_a">首页</a></li>-->
            <!--<li class="item_li"><a href="/zzgg" class="item_a">正在公告</a></li>-->
            <!--<li class="item_li"><a href="/zzgp" class="item_a">正在挂牌</a></li>-->
            <!--&lt;!&ndash;<li class="item_li"><a href="javascript:void(0);" class="item_a">正在资审</a></li>&ndash;&gt;-->
            <!--<li class="item_li"><a href="/jggs" class="item_a">结果公示</a></li>-->
            <!--<li class="item_li"><a href="/sygp" class="item_a">所有挂牌</a></li>-->
            <!--<li class="item_li"><a href="/gzgg" class="item_a">其它公告</a></li>-->
            <!--<li class="item_li"><a href="/zlxz" class="item_a">资料下载</a></li>-->
            <!--</ul>-->
            <ul class="w_1200 nav_ul" @click="clickNav">
                <li class="item_li">
                    <router-link class="item_a" tag="a" to="/">首页</router-link>
                </li>
                <li class="item_li">
                    <router-link class="item_a" tag="a" to="/zzgg">正在公告</router-link>
                </li>
                <li class="item_li">
                    <router-link class="item_a" tag="a" to="/zzgp">正在挂牌</router-link>
                </li>
                <li class="item_li">
                    <router-link class="item_a" tag="a" to="/zzzs">结果待公示</router-link>
                </li>
                <li class="item_li">
                    <router-link class="item_a" tag="a" to="/jggs">结果公示</router-link>
                </li>
                <li class="item_li" hidden>
                    <router-link class="item_a" tag="a" to="/sygp">所有挂牌</router-link>
                </li>
                <li class="item_li">
                    <router-link class="item_a" tag="a" to="/qtgg">其它公告</router-link>
                </li>
                <li class="item_li">
                    <router-link class="item_a" tag="a" to="/zlxz">资料下载</router-link>
                </li>
            </ul>
        </div>
        <!--end导航-->
    </div>
</template>

<script>
    import {getQueryVariable, findKey} from '@/core/common'

    export default {
        name: "Header",
        data() {
            return {
                active_nav: null,
                nav: {
                    "zzgg": "01",
                    "zzgp": "02",
                    "jggs": "03",
                    "sygp": "04",
                    "qwss": "05",
                    "zzzs": "06",
                },
            }
        },
        mounted() {
            this.active_nav = '/' + this.getNav();
            const nav = getQueryVariable("nav");
            if (nav) {
                this.active_nav = '/' + findKey(this.nav, nav);
                let navDom = document.querySelector('[href="/gtzyjygcxx' + this.active_nav + '"][class="item_a"]');
                if (navDom !== null) {
                    setTimeout(() => {
                        navDom.parentNode.classList.add('active')
                    }, 100);
                }
            }
        },
        methods: {
            getNav() {
                let category = window.location.pathname.split('/')[2];
                if (category === 'tzgg') {
                    return 'gzgg'
                } else if (category !== undefined) {
                    return category
                } else {
                    return ""
                }
            },
            clickNav() {
                this.active_nav = '/' + this.getNav();
                this.changeActiveNav()
            },
            changeActiveNav() {
                document.getElementsByClassName("item_li").forEach(e => e.classList.remove('active'));
                let activeLink = document.getElementsByClassName('router-link-exact-active');
                if (activeLink.length > 0) {
                    activeLink[activeLink.length - 1].parentNode.classList.add('active');
                }
            }
        },
        watch: {
            active_nav: function () {
                this.changeActiveNav()
            },
            "$route": {
                handler() {
                    setTimeout(this.changeActiveNav, 100);
                }
            }
        }
    }
</script>

<style scoped>
    .nav {
        z-index: 100;
    }
</style>
